import { Box, Icon, type IIconsVector, type InputRadioProps, Typography } from 'shared/ui'
import { type INumberType, type ITargetCountry } from 'entities/Compliance/api/types/complianceType'
import styles from 'entities/Compliance/ui/Questionnaire/ui/QuestionSection/ui/styles.module.scss'

export const getFirstBlockItems = (
  targetCountry: ITargetCountry | null,
  onChecked: (index: ITargetCountry) => void
): InputRadioProps[] => [
  {
    label: <span className={styles.labelText}>US only</span>,
    checked: targetCountry === 'US',
    leftIcon: 'flagUSA' as IIconsVector,
    onChecked: () => onChecked('US'),
  },
  {
    label: <span className={styles.labelText}>Canada only</span>,
    checked: targetCountry === 'CA',
    leftIcon: 'flagCanada' as IIconsVector,
    onChecked: () => onChecked('CA'),
  },
  {
    label: <span className={styles.labelText}>UK only</span>,
    checked: targetCountry === 'GB',
    leftIcon: 'flagUK' as IIconsVector,
    onChecked: () => onChecked('GB'),
  },
  {
    customLabel: (
      <div className={styles.customLabel}>
        <Icon icon={'flagUSA'} className={styles.leftIcon} /> US
        <span>+</span>
        <Icon icon={'flagCanada'} className={styles.leftCaIcon} /> Canada
      </div>
    ),
    checked: targetCountry === 'ALL',
    onChecked: () => onChecked('ALL'),
  },

  {
    label: <span className={styles.labelText}>All supported countries</span>,
    checked: targetCountry === 'ALL_GB',
    leftIcon: 'salesmsg' as IIconsVector,
    onChecked: () => onChecked('ALL_GB'),
  },
]

export const getSecondBlockItems = (
  isTaxId: boolean | null,
  onChecked: (condition: boolean) => void
): InputRadioProps[] => [
  {
    label: (
      <>
        <Icon icon={'tickSymbol'} className={styles.leftIcon} />
        <span className={styles.taxIdLabelText}>Yes, I do</span>
      </>
    ),
    checked: isTaxId === null ? false : isTaxId,
    onChecked: () => onChecked(true),
  },
  {
    label: (
      <>
        <Icon icon={'crossMark'} className={styles.leftIcon} />
        <span className={styles.taxIdLabelText}>No, I don’t</span>
      </>
    ),
    checked: isTaxId === null ? false : !isTaxId,
    onChecked: () => onChecked(false),
  },
]

export const getThirdBlockItems = (
  numberType: INumberType | null,
  onChecked: (type: INumberType) => void
): InputRadioProps[] => {
  return [
    {
      label: 'Local numbers',
      rightText: (
        <Box display={'flex'} gap={'8px'} alignItems={'center'}>
          <Typography ariaLabel='example' variant='body-rg-regular'>
            e.g. (561) 555-5555
          </Typography>
        </Box>
      ),
      checked: numberType === 'local',
      onChecked: () => onChecked('local'),
    },
    {
      label: 'Toll-free numbers',
      rightText: (
        <Typography ariaLabel='example' variant='body-rg-regular'>
          e.g. (888) 555-5555
        </Typography>
      ),
      checked: numberType === 'toll_free',
      onChecked: () => onChecked('toll_free'),
    },
    {
      label: 'Local numbers + Toll-free numbers',
      checked: numberType === 'all',
      onChecked: () => onChecked('all'),
    },
  ]
}
